import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { INPUT_TYPES } from '../../../config/constants';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';

const HEIGHT_TYPES = {
    LONG: 'long',
    SHORT: 'short'
}

const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class TextInput extends Component {

    state = {
        heightType: this.props.initialValues.type === INPUT_TYPES.TEXTAREA ? HEIGHT_TYPES.LONG : HEIGHT_TYPES.SHORT,
        label: this.props.initialValues.label || (this.isEmail ? 'Email' :  'Text input'),
        placeholder: this.props.initialValues.placeholder || (this.isEmail ? 'Email' :  'Type...'),
        required: this.props.initialValues.isRequired || false,
        confirmEmailOption: this.props.initialValues.withConfirmEmailOption || false,

        textValue: '',
        textAreaValue: '',
        emailValue: '',
        repeatEmailValue: '',

        confirmEmailNotMatchError: false,
        confirmEmailNotValidError: false,
        emailNotValidError: false,
        requiredError: !!this.props.initialValues.isRequired
    };

    get isEmail() {
        return this.props.initialValues.type === INPUT_TYPES.EMAIL;
    }

    updateInputPropsInStore = () => {
        const {
            heightType, label, placeholder, required,
            confirmEmailOption, confirmEmailNotMatchError,
            confirmEmailNotValidError, emailNotValidError, requiredError
        } = this.state;

        const inputProps = {
            label, placeholder,
            isRequired: required,
            type: this.props.initialValues.type,
            _value: '',
            _hasValidationErrors: false,
        };

        if (inputProps.type === INPUT_TYPES.EMAIL) {
            inputProps['withConfirmEmailOption'] = confirmEmailOption;
            inputProps._value = this.state.emailValue;
            inputProps._hasValidationErrors = confirmEmailNotMatchError || confirmEmailNotValidError || emailNotValidError || requiredError;
        } else {
            inputProps._hasValidationErrors = requiredError;

            if (heightType === HEIGHT_TYPES.LONG) {
                inputProps.type = INPUT_TYPES.TEXTAREA;
                inputProps._value = this.state.textAreaValue;
            } else {
                inputProps.type = INPUT_TYPES.INPUT;
                inputProps._value = this.state.textValue;
            }
        }

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setHeight = (e) => {
        let heightType = e.target.value;
        this.setState({ heightType: heightType });
    };

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setPlaceholder = (e) => {
        this.setState({ placeholder: e.target.value });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked });
    };

    setConfirmEmailOption = (e) => {
        this.setState({ confirmEmailOption: e.target.checked })
    };

    setValue = (name, e) => {
        this.setState({ [name]: e.target.value }, () => {
            this.updateRequiredError();
        });
    };

    setEmailValue = (name, e) => {
        const value =  e.target.value;

        const newState = { [name]: value };

        if (name === 'emailValue') {
            newState['emailNotValidError'] = value && !emailRegexp.test(value);
            newState['confirmEmailNotMatchError'] = (this.state.repeatEmailValue && value) ? this.state.repeatEmailValue.toLowerCase() !== value.toLowerCase() : false;
        }

        if (name === 'repeatEmailValue') {
            newState['confirmEmailNotValidError'] = value && !emailRegexp.test(value);
            newState['confirmEmailNotMatchError'] = (this.state.emailValue && value) ? this.state.emailValue.toLowerCase() !== value.toLowerCase() : false;
        }

        this.setState(newState, () => {
            this.updateRequiredError();
        });
    }

    updateRequiredError = () => {
        let requiredError;
        if (!this.state.required) {
            requiredError = false;
        } else {
            if (this.isEmail) {
                if (!this.state.confirmEmailOption) {
                    requiredError = !this.state.emailValue;
                } else {
                    requiredError = !this.state.emailValue || !this.state.repeatEmailValue;
                }
            }
            else if (this.state.heightType === HEIGHT_TYPES.LONG) {
                requiredError = !this.state.textAreaValue;
            } else {
                requiredError = !this.state.textValue;
            }
        }
        this.setState({ requiredError });
    }

    render() {
        const { confirmEmailNotMatchError, confirmEmailNotValidError, emailNotValidError, requiredError } = this.state;
        const { textColor, initialValues, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={requiredError}
                >
                    <>
                        <div
                            className={`default-input-wrapper ${this.state.heightType === HEIGHT_TYPES.LONG ? 'textarea-wrapper' : ''}`}
                            data-validation-error={emailNotValidError}
                        >
                            {
                                this.isEmail ?
                                    <input
                                        value={this.state.emailValue}
                                        onChange={(e) => this.setEmailValue('emailValue', e)}
                                        className="default-input"
                                        placeholder={this.state.placeholder}
                                        type="email"
                                    />
                                    :
                                    this.state.heightType === HEIGHT_TYPES.SHORT ?
                                        <input
                                            value={this.state.textValue}
                                            onChange={(e) => this.setValue('textValue', e)}
                                            className="default-input"
                                            placeholder={this.state.placeholder}
                                            type="text"
                                        />
                                        :
                                        <textarea
                                            value={this.state.textAreaValue}
                                            onChange={(e) => this.setValue('textAreaValue', e)}
                                            rows="6"
                                            cols="50"
                                            placeholder={this.state.placeholder}
                                        />
                            }
                        </div>
                        { emailNotValidError && <span className="validation-error-text">Email is not valid</span> }

                        {

                            this.state.confirmEmailOption &&
                            <>
                                <div
                                    style={{ marginTop: '20px' }}
                                    className="default-input-wrapper"
                                    data-validation-error={confirmEmailNotMatchError || confirmEmailNotValidError}
                                >
                                    <input
                                        value={this.state.repeatEmailValue}
                                        onChange={(e) => this.setEmailValue('repeatEmailValue', e)}
                                        className="default-input confirm-email_value"
                                        placeholder="Confirm your email"
                                        type="email"
                                        autoComplete="new-password"
                                    />
                                </div>
                                {
                                    confirmEmailNotMatchError &&
                                    <span className="validation-error-text">Emails do not match</span>
                                }
                                {
                                    confirmEmailNotValidError &&
                                    <span className="validation-error-text">Confirm email is not valid</span>
                                }
                            </>
                        }
                    </>

                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            {
                                !this.isEmail &&
                                <label>
                                    <select
                                        value={this.state.heightType}
                                        onChange={this.setHeight}
                                    >
                                        <option>{ HEIGHT_TYPES.SHORT }</option>
                                        <option>{ HEIGHT_TYPES.LONG }</option>
                                    </select>
                                    height
                                </label>
                            }

                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>
                            <label>
                                <input value={this.state.placeholder} onChange={this.setPlaceholder} type="text"/>
                                placeholder
                            </label>
                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>
                            {
                                this.isEmail &&
                                <label>
                                    <input
                                        checked={this.state.confirmEmailOption}
                                        onChange={this.setConfirmEmailOption}
                                        className="confirm-email_option"
                                        type="checkbox"
                                    />
                                    with confirm email option
                                </label>
                            }
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(TextInput);
